// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as PorterStoreProductRepoConfig from "./PorterStoreProductRepoConfig.bs.js";

var dummyProductsResponse = [
    {
      "id": 12345,
      "code": "TSHIRT-001",
      "name": "Classic Cotton T-Shirt",
      "description": "Comfortable everyday wear",
      "list_amount_minor": 1999,
      "sale_amount_minor": 1499,
      "currency_code": "INR",
      "is_active": true,
      "created_at": "2026-01-13T10:30:00Z",
      "updated_at": "2026-01-13T10:30:00Z"
    },
    {
      "id": 23456,
      "code": "TSHIRT-002",
      "name": "Premium Cotton T-Shirt",
      "description": "Luxury everyday wear",
      "list_amount_minor": 2999,
      "sale_amount_minor": 2499,
      "currency_code": "INR",
      "is_active": true,
      "created_at": "2026-01-13T10:30:00Z",
      "updated_at": "2026-01-13T10:30:00Z"
    }
  ];

var dummyProductDetailResponse = {
    "product": {
      "id": 12345,
      "code": "TSHIRT-001",
      "name": "Classic Cotton T-Shirt",
      "description": "Comfortable everyday wear made from 100% organic cotton",
      "is_active": true,
      "list_amount_minor": 2999,
      "sale_amount_minor": 2499,
      "currency_code": "USD",
      "created_at": "2026-01-10T10:30:00Z",
      "updated_at": "2026-01-13T15:45:00Z"
    },
    "translations": [
      {
        "id": 601,
        "product_id": 12345,
        "language_code": "hi",
        "name": "क्लासिक कॉटन टी-शर्ट",
        "description": "100% जैविक कपास से बना आरामदायक रोजमर्रा का पहनावा",
        "created_at": "2026-01-10T10:30:00Z"
      }
    ],
    "images": [
      {
        "id": 801,
        "product_id": 12345,
        "image_url": "https://cdn.example.com/products/tshirt-001-front.jpg",
        "display_order": 1,
        "created_at": "2026-01-10T10:30:00Z"
      }
    ],
    "variants": [
      {
        "id": 501,
        "product_id": 12345,
        "sku": "TSHIRT-001-S-BLK",
        "size_code": "S",
        "stock_quantity": 150,
        "is_active": true,
        "created_at": "2026-01-10T10:30:00Z",
        "updated_at": "2026-01-13T09:00:00Z"
      }
    ],
    "price_overrides": [
      {
        "id": 701,
        "product_id": 12345,
        "geo_region_id": 101,
        "list_amount_minor": 24999,
        "sale_amount_minor": 19999,
        "currency_code": "INR"
      }
    ],
    "availability": [
      {
        "id": 901,
        "product_id": 12345,
        "supplier_id": 201,
        "supplier": {
          "id": 201,
          "name": "Fast Logistics India",
          "cashfree_vendor_id": "vendor_fl_india_001",
          "is_active": true,
          "created_at": "2026-01-05T08:00:00Z"
        },
        "geo_region_id": 101,
        "is_active": true,
        "priority": 1,
        "created_at": "2026-01-10T10:30:00Z",
        "updated_at": "2026-01-12T15:45:00Z"
      }
    ],
    "validations": [
      {
        "id": 1001,
        "target": {
          "target_id": 12345,
          "target_type": "PRODUCT"
        },
        "validation_type": "ROLLING_WINDOW_CAP",
        "scope": "GLOBAL",
        "geo_region_id": null,
        "config": {
          "max_allowed_count": 2,
          "rolling_window_days": 45,
          "required_product_id": null
        },
        "is_active": false,
        "created_at": "2026-01-13T10:30:00Z",
        "updated_at": "2026-01-13T15:10:00Z"
      }
    ]
  };

function fetchProducts(_country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyProductsResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(PorterStoreProductRepoConfig.PorterStoreProductListResponseConverter.execute, result);
                        });
            });
}

function fetchProductDetail(param, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyProductDetailResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(PorterStoreProductRepoConfig.PorterStoreProductDetailResponseConverter.execute, result);
                        });
            });
}

var PorterStoreProductRepo = {
  fetchProducts: fetchProducts,
  fetchProductDetail: fetchProductDetail
};

export {
  PorterStoreProductRepo ,
  
}
/* PorterStoreProductRepoConfig Not a pure module */
